<template>
  <main>
    <div class="cont">
      <nav class="steps">
        <p class="on">
          <i>1</i>
          <span>重设密码</span>
        </p>
        <p :class="{ on: step > 0 }">
          <i>2</i>
          <span>修改成功</span>
        </p>
      </nav>
      <ul v-show="step === 0">
        <li>
          <el-input v-model="info.code" placeholder="请输入手机验证码">
            <el-button slot="append" @click="sendSMS">{{ codeTime === null ? '获取验证码' : codeTime+'s' }}</el-button>
          </el-input>
        </li>
        <li>
          <el-input maxlength="11" type="password" v-model="info.password" placeholder="请输入至少6位数的新密码"></el-input>
        </li>
        <li>
          <el-input maxlength="11" type="password" v-model="info.repeatPassword" placeholder="确认密码"></el-input>
        </li>
      </ul>
      <div class="btn" v-show="step === 0" >
        <button class="next" @click="updatePwd">修改</button>
      </div>
      <div class="success" v-show="step === 1">
        <i class="icon-gou"></i>
        <p>修改密码成功！{{timing}}s后返回<router-link :to="{name: 'user'}">用户主页</router-link></p>
      </div>
    </div>
  </main>
</template>

<script>
import $user from '@api/user';
import $strategy from '@assets/js/strategy';
export default {
  data () {
    return {
      step: 0,
      info: {
        password: null,
        repeatPassword: null,
        code: null
      },
      codeTime: null,
      timing: 5
    }
  },
  created () {
  },
  methods: {
    updatePwd () {
      const { code, password, repeatPassword } = this.info;
      if ( $strategy.check(code, 'isEmpty') || code.length < 4 ) {
        this.$message.warning('验证码有误！');
        return;
      }
      if ( $strategy.check(password, 'isEmpty') || password.length < 6 ) {
        this.$message.warning('密码格式有误，请检查！');
        return;
      }
      if ( password !== repeatPassword ) {
        this.$message.warning('密码不一致！');
        return;
      }
      const data = this.getRequestData();
      $user.updatePassword(data).then(res => {
        this.step = 1;
        this.countdown();
      });
    },
    getRequestData () {
      const { code, password } = this.info;
      return { phoneCode: code, password };
    },
    // 发送短信
    sendSMS () {
      if ( this.codeTime !== null ) { return; }
      this.startCountdown('codeTime');
      $user.getPhoneCodeWithResetPWD();
    },
    countdown () {
      let timing = setInterval(() => {
        if (this.timing === 1) {
          clearInterval(timing);
          this.$router.push({ name: 'user' });
        } else {
          this.timing -= 1;
        }
      }, 1000);
    }
  }
}
</script>

<style scoped src="./register.css"></style>